import 'styles/globals.css';
import type { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import WebpWithFallback from 'components/helpers/WebpWithFallback';
import { ErrorBoundary, ObservabilityInit } from 'components/helpers/Observability';
import { NmdpAppProvider } from 'components/globalContext/NmdpAppProvider';

const App = ({ Component, pageProps }: AppProps) => {
  const router = useRouter();
  useEffect(() => {
    const storeLocalReferrer = () => {
      window.sessionStorage.setItem('errRef', router.asPath);
    };
    router.events.on('routeChangeError', storeLocalReferrer);
    return () => {
      router.events.off('routeChangeError', storeLocalReferrer);
    };
  }, [router.asPath, router.events]);

  return (
    <NmdpAppProvider>
      <WebpWithFallback feature="lossy" />
      <ObservabilityInit />
      <ErrorBoundary>
        <>
          <Component {...pageProps} />
        </>
      </ErrorBoundary>
    </NmdpAppProvider>
  );
};

export default App;
